import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/Layout.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err)
}

/**
 * name -> 同path，多级路由时用 . 分割
 * meta.title -> 面包屑中的菜单名称
 * meta.smooth -> 设为false在切换页面时不会平滑地滚动到顶部，否则会平滑地滚动到顶部
 */
const routes = [
  {
    path: '/',
    name: 'index',
    redirect: '/news',
    component: Layout,
    meta: { title: '巨石创投官网' },
    children: [
      {
        path: 'news',
        name: 'news',
        component: () => import('@/views/news/index.vue'),
        meta: { title: '资讯', smooth: false }
      },
      {
        path: 'news/:tabId',
        name: 'news',
        component: () => import('@/views/news/index.vue'),
        meta: { title: '资讯', smooth: false },
        children: [
          // {
          //   path: 'calendar',
          //   name: 'calendar',
          //   component: () => import('@/views/news/investCalendarPage.vue'),
          //   meta: { title: '投资日历' }
          // }
        ]
      },
      {
        path: 'calendar',
        name: 'calendar',
        component: () => import('@/views/news/investCalendarPage.vue'),
        meta: { title: '投资日历' }
      },
      {
        path: 'subjectpage',
        name: 'subjectpage',
        component: () => import('@/views/news/subjectListPage.vue'),
        meta: { title: '专题列表页' }
      },
      {
        path: 'detail/:docId/:extend',
        name: 'detail',
        component: () => import('@/views/news/detailPage.vue'),
        meta: { title: '详情页' }
      },
      {
        path: 'vdetail/:docId/:extend',
        name: 'vdetail',
        component: () => import('@/views/news/videoDetailPage.vue'),
        meta: { title: '视频详情页' }
      }
      // {
      //   path: 'fdetail/:docId',
      //   name: 'finaceDetail',
      //   component: () => import('@/views/news/FinanceDetailPage.vue')
      // }
    ]
  },
  {
    path: '/fdetail/:docId',
    name: 'finaceDetail',
    component: () => import('@/views/news/FinanceDetailPage.vue')
  },
  // {
  //   path: '/test',
  //   component: () => import('@/views/Test.vue')
  // },
  {
    path: '*',
    component: () => import('@/views/404.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.VUE_APP_PUBLIC_PATH,
  scrollBehavior(to) {
    if (to.meta.smooth === false) {
      return { x: 0, y: 0 }
    } else {
      return { x: 0, y: 0, behavior: 'smooth' }
    }
  },
  routes
})

export { router }
